import PropTypes from 'prop-types';
import React from 'react';

import classnames from 'classnames';
import { ChevronDown, Plus, ChevronUp, Trash } from 'lucide-react';
import { ButtonIcon, Col, Button, Input, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, Separator, DefaultTable, Badge, DefaultTooltip, ToggleOptionGroup, ToggleOptionGroupItem } from 'twyne-new.ui'

class SelectOptions extends React.Component {
  state = {
    sortedField: 'value',
    sortedOrder: 'asc',
  }

  handleChange = change => {
    const { options, onChange } = this.props
    change(options)
    onChange({ options })
  }

  addOption = () => {
    this.handleChange(options => options.push({ value: '', label: '' }))
  }

  removeOption = index => {
    this.handleChange(options => options.splice(index, 1))
  }

  handleChangeOptionInput = (type, id, options) => evt => {
    const { onChange } = this.props
    let { value } = evt.target

    if (type === 'value') {
      value = value.replace(/[}{,()$]/g, '')
      let repeatedValues = this.props.repeatedValuesSelect

      options.find((item, index) => {
        const result = index !== id && item.value === value

        if (result) {
          repeatedValues[id] = true
        } else {
          delete repeatedValues[id]
        }

        return result
      })

      onChange({ repeatedValuesSelect: repeatedValues })
    }

    this.handleChange(options => {
      options[id][type] = value
    })
  }

  handleChangeSorter = (type, order) => {
    const { options, onChange } = this.props
    const sorted = options.sort((a, b) => order === "desc" ? b[type].localeCompare(a[type]) : a[type].localeCompare(b[type]))
    onChange({ options: sorted })
  }

  Option = () => {
    const { options } = this.props;

    const columns = [{
      dataField: 'value',
      text: 'Value',
      formatter: (col, _row, index) => <div className='relative'>
        <Input required
          className={classnames({ "is-invalid": !!this.props.repeatedValuesSelect[index] })}
          name={`options[${index}].value`}
          value={col}
          placeholder="Value"
          onChange={this.handleChangeOptionInput('value', index, options)}
        />
        <span className="invalid-feedback absolute -bottom-4 left-0">The value must be unique.</span>
      </div>,
    }, {
      dataField: 'label',
      text: 'Label',
      formatter: (col, _row, index) => <Input required
        name={`options[${index}].label`}
        value={col}
        placeholder="Label"
        onChange={this.handleChangeOptionInput('label', index)}
      />,
    }, {
      dataField: '',
      text: '',
      formatter: (_col, _row, index) => <ButtonIcon
        content='Delete'
        onClick={() => this.removeOption(index)}
      >
        <Trash size={16} />
      </ButtonIcon>,
      className: 'w-8',
    }]

    return <Col size='12' className='max-h-70 overflow-x-hidden overflow-y-auto'>
      <DefaultTable
        data={options}
        columns={columns}
        noDataIndication={() => 'No options to show.'}
      />
    </Col>
  }

  render() {
    const handleChangeSortedField = field => {
      this.setState({ sortedField: field })
      this.handleChangeSorter(field, this.state.sortedOrder)
    }

    const handleChangeSortedOrder = order => {
      this.setState({ sortedOrder: order })
      this.handleChangeSorter(this.state.sortedField, order)
    }

    return <>
      <Col size="12">
        <div className="relative flex items-center">
          <div className='text-lg twy-text-base-accent mb-2'>Options</div>
          <span className="flex items-center gap-2 absolute top-0 right-0">
            <DropdownMenu size='sm' optionsLabel='Sort by' value={this.state.sortedField}>
              <DropdownMenuTrigger asChild>
                <Badge variant='light' className='uppercase self-center cursor-pointer'>{this.state.sortedField || 'Sort by'} <ChevronDown size={12} /></Badge>
              </DropdownMenuTrigger>
              <DropdownMenuContent className='min-w-24' >
                <DropdownMenuItem onClick={() => handleChangeSortedField('value')} value='value'>
                  Value
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => handleChangeSortedField('label')} value='label'>
                  Label
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            <ToggleOptionGroup size='md' value={this.state.sortedOrder} type='single' onValueChange={value => value && handleChangeSortedOrder(value)}>
              <ToggleOptionGroupItem value='asc' className='py-0'>
                <DefaultTooltip content='Ascending' triggerProps={{ className: 'w-full flex justify-center' }}>
                  <ChevronUp size='16' />
                </DefaultTooltip>
              </ToggleOptionGroupItem>
              <ToggleOptionGroupItem value='desc' className='py-0'>
                <DefaultTooltip content='Descending' triggerProps={{ className: 'w-full flex justify-center' }}>
                  <ChevronDown size='16' />
                </DefaultTooltip>
              </ToggleOptionGroupItem>
            </ToggleOptionGroup>
            <Separator orientation='vertical' className='py-3' />
            <Button size="sm" color="accent" onClick={this.addOption}>
              <Plus size={14} />
              Add
            </Button>
          </span>
        </div>
      </Col>
      <this.Option />
    </>
  }
}

SelectOptions.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
};

export default SelectOptions;
